<template>
  <generic-view
    :title="$t('inventory flow')"
    icon="exchange"
    :header_buttons="header_buttons"
  >
    <div class="ui grid">
      <div class="eight wide column">
        <div class="ui dividing header">
          <i class="chevron right icon"></i>
          {{ $t("input to inventory") }}
        </div>
        <table class="ui celled very compact orange striped table" ref="tbl_in">
          <thead>
            <tr>
              <th>{{ $t("date") }}</th>
              <th>{{ $t("reason") }}</th>
              <th>{{ $t("quantity") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(inp, idx) in in_to" :key="idx">
              <td data-label="date">
                {{
                  inp.inv_input.create_date
                    | formatDate(enterprise_setup.simple_date_format)
                }}
              </td>
              <td data-label="reason">{{ inp.inv_input.reason }}</td>
              <td data-label="quantity">{{ inp.quantity }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="eight wide column">
        <div class="ui dividing header">
          <i class="chevron left icon"></i>
          {{ $t("output from inventory") }}
        </div>
        <table class="ui celled very compact olive striped table" ref="tbl_out">
          <thead>
            <tr>
              <th>{{ $t("date") }}</th>
              <th>{{ $t("reason") }}</th>
              <th>{{ $t("quantity") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(out, idx) in out_from" :key="idx">
              <td data-label="date">
                {{
                  out.inv_output.create_date
                    | formatDate(enterprise_setup.simple_date_format)
                }}
              </td>
              <td data-label="reason">{{ out.inv_output.reason }}</td>
              <td data-label="quantity">{{ out.quantity }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </generic-view>
</template>

<script>
import { local_api, stringify, enterprise_setup } from "@/utils";
import filters from "@/filters";
import GenericView from "@/components/GenericContainer";
import "datatables.net";
import "datatables.net-se";

export default {
  filters: filters,
  props: {
    module: Object,
    product: Object,
  },
  components: {
    "generic-view": GenericView,
  },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  data() {
    return {
      in_to: [],
      out_from: [],
      header_buttons: [{ icon: "green refresh", click: this.refresh }],
    };
  },
  methods: {
    refresh() {
      let vm = this;
      local_api(vm, "post", "/product_inventory_flow/do-get-initial-items", {
        uuid: vm.product.uuid,
      })
        .then((data) => {
          if (data) {
            vm.in_to = data.inv_input_products;
            vm.out_from = data.inv_output_products;
            setTimeout(() => {
              let dict =
                "//cdn.datatables.net/plug-ins/1.10.21/i18n/English.json";
              if (vm.$i18n.locale == "es")
                dict =
                  "//cdn.datatables.net/plug-ins/1.10.21/i18n/Spanish.json";
              else if (vm.$i18n.locale == "fr")
                dict = "//cdn.datatables.net/plug-ins/1.10.21/i18n/French.json";

              if (window.jQuery.fn.DataTable.isDataTable(vm.$refs.tbl_in)) {
                window
                  .jQuery(vm.$refs.tbl_in)
                  .DataTable()
                  .destroy();
              }

              if (window.jQuery.fn.DataTable.isDataTable(vm.$refs.tbl_out)) {
                window
                  .jQuery(vm.$refs.tbl_out)
                  .DataTable()
                  .destroy();
              }

              let inTbl = window.jQuery(vm.$refs.tbl_in).DataTable({
                language: {
                  url: dict,
                },
                info: false,
                searching: false,
              });
              let outTbl = window.jQuery(vm.$refs.tbl_out).DataTable({
                language: {
                  url: dict,
                },
                info: false,
                searching: false,
              });

              inTbl.on("draw.dt", function() {
                let p = window.jQuery(".dataTables_length").parent();
                if (p)
                  p.removeClass("eight wide column").addClass(
                    "sixteen wide column",
                  );
              });

              outTbl.on("draw.dt", function() {
                let p = window.jQuery(".dataTables_length").parent();
                if (p)
                  p.removeClass("eight wide column").addClass(
                    "sixteen wide column",
                  );
              });
            }, 300);
          }
        })
        .catch((err) => {
          vm.$alertify.error(stringify(err));
        });
    },
  },
  created() {},
  mounted() {
    let vm = this;
    setTimeout(() => {
      vm.refresh();
    }, 200);
  },
  watch: {},
};
</script>

<style scoped></style>
